import assetManagementPb from "@/proto/asset-mgmt/assetManagement_pb";
import assetManagementPbService from "@/proto/asset-mgmt/assetManagement_pb_service";
import utilPb from "@/proto/asset/util_pb";
import {
  API_URL,
  responseWrapper,
  createRequestPagination,
  Pagination,
} from "./util";
import { getMetadata } from "./metadata";

const client = new assetManagementPbService.AssetManagementServiceClient(
  API_URL,
);

export const getListAssetNode = (payload: { pagination: Pagination }) => {
  return new Promise(
    (
      resolve: (res: assetManagementPb.AssetNodeListResponse.AsObject) => void,
      reject: (err: string) => void,
    ) => {
      const req = new assetManagementPb.GetListAssetNodeRequest();
      req.setPagination(createRequestPagination(payload.pagination));

      getMetadata().then((metadata) => {
        client.getListAssetNode(
          req,
          metadata,
          responseWrapper(resolve, reject),
        );
      });
    },
  );
};

export const uploadListAsset = (payload: {
  assetList: assetManagementPb.Asset[];
  columns: assetManagementPb.AssetColumns;
}) => {
  return new Promise(
    (
      resolve: (res: utilPb.Empty.AsObject) => void,
      reject: (err: string) => void,
    ) => {
      const req = new assetManagementPb.UploadListAssetRequest();
      req.setAssetListList(payload.assetList);
      req.setColumns(payload.columns);

      getMetadata().then((metadata) => {
        client.uploadListAsset(req, metadata, responseWrapper(resolve, reject));
      });
    },
  );
};
